import { useTranslation } from "react-i18next";

import { useHighlighted } from "contexts/highlighted";

import { useObjectData } from "./useObjectData";

/**
 * Subtitle shown in the header of the Properties panel/drawer.
 * - Multiple selection: localized "<n> objects selected".
 * - Single selection: object's "Name" property, falling back to "Object <id>".
 * - No selection: undefined.
 */
export function usePropertiesPanelSubtitle(): string | undefined {
    const { t } = useTranslation();
    const highlighted = useHighlighted();
    const { object } = useObjectData();

    const count = highlighted.idArr.length;
    if (count > 1) {
        return t("objectsSelectedCount", { count });
    }
    if (count === 1) {
        return object?.base.find(([key]) => key === "Name")?.[1] ?? (object ? `Object ${object.id}` : undefined);
    }
    return undefined;
}
